/* unplugin-vue-components disabled */import { render } from "./lowCode.vue?vue&type=template&id=67ce8e02"
import script from "./lowCode.vue?vue&type=script&lang=js"
export * from "./lowCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__